import  { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import {
  BrowserRouter as Router,
  Routes,
  Route,

  Outlet,
} from "react-router-dom";
import "./assets/globalstyle/globalstyle.scss";

import { ToastContainer as DefaultToastContainer } from "react-toastify";

// Import Contexts
import { theme, ThemeProvider } from "./context/ThemeProvider";
import NoPage from "./components/UnknownPage";

// Other assets
import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";

// Import Pages
import Dashboard from "./pages/Dashboard";
// import { useSelector } from "react-redux";
import {
  LoggedInRoute,
  ProtectedRoutes,
} from "./utils/GlobalUtils/ProtectedRoutes";
import ChangeBankAccount from "./layouts/Settings/ChangeBankAccount";
import KYCVerification from "./layouts/Kyc/KYCVerification";

const Wallet = lazy(() => import("./layouts/wallet/Index"));

const FundWallet = lazy(() => import("./layouts/AgencyBanking/FundWallet"));
const SendMoney = lazy(() => import("./layouts/AgencyBanking/SendMoney"));

const DownLines = lazy(() => import("./layouts/AgencyManagement/DownLines"));
const DownlineDetails = lazy(() =>
  import("./layouts/AgencyManagement/DownlineDetails")
);
const AddDownline = lazy(() =>
  import("./layouts/AgencyManagement/AddDownline")
);
const AddAggregators = lazy(() =>
  import("./layouts/AgencyManagement/AddAggregators")
);
const Aggregators = lazy(() =>
  import("./layouts/AgencyManagement/Aggregators")
);

const Onboarding = lazy(() =>
  import("./pages/authPages/onboarding/Onboarding")
);

const ActivateAccountBySettingPassword = lazy(() =>
  import("./pages/authPages/resetPassword/ActivateAccountBySettingPassword")
);

const FinalOnboarding = lazy(() =>
  import("./pages/authPages/onboarding/FinalOnboarding")
);

const ForgotPassword = lazy(() =>
  import("./pages/authPages/forgotPassword/ForgotPassword")
);

const OtpPassword = lazy(() =>
  import("./pages/authPages/otpPassword/OtpPassword")
);

const ResetPassword = lazy(() =>
  import("./pages/authPages/resetPassword/ResetPassword")
);

const ResetPasswordSuccess = lazy(() =>
  import("./pages/authPages/resetPasswordSuccess/ResetPasswordSuccess")
);

const AccountSetup = lazy(() =>
  import("./components/Account-setup/AccountSetup")
);

const DashboardIndexSection = lazy(() => import("./layouts/dashboard/Index"));

const Profile = lazy(() => import("./layouts/Settings/Profile"));

const Support = lazy(() => import("./layouts/Settings/Support"));
const AccountLimit = lazy(() => import("./layouts/Settings/AccountLimit"));
const BuyAirtime = lazy(() => import("./layouts/Products/airtime/Airtime"));
const Betting = lazy(() => import("./layouts/Products/betting/Betting"));

const BuyData = lazy(() => import("./layouts/Products/data/data"));

const Electricity = lazy(() =>
    import("./layouts/Products/electricity/Electricity")
);

const CableTv = lazy(() =>
    import("./layouts/Products/cable-tv/CableTelevision")
);

const FlexDealFacialVerification = lazy(() =>
  import("./pages/FlexDealFacialVerification")
);

const Products = lazy(() => import("./layouts/Products/Products"));
const ReportMainWallet = lazy(() => import("./layouts/Report/MainWallet"));

const CommissionWalletReport = lazy(() =>
    import("./layouts/Report/Commision/MyTransaction")
);

const PendingTransaction = lazy(() =>
  import("./layouts/Report/PendingTransaction")
);

const Performance = lazy(() => import("./layouts/Performance"));

const TransactionPin = lazy(() => import("./layouts/Settings/TransactionPin"));

const PaymentTransactions = lazy(() =>
  import("./layouts/Settings/Transactions")
);
const PaymentDisbursments = lazy(() =>
  import("./layouts/Settings/ChangePassword")
);
const Commission = lazy(() => import("./layouts/Commission/Commission"));
const Login = lazy(() => import("./pages/authPages/login/Login"));
const SignupPage = lazy(() => import("./pages/authPages/signup/SignupPage"));
const Register = lazy(() => import("./pages/authPages/signup/Register"));
const Holding = lazy(() => import("./pages/authPages/login/HoldingPage"));

// create a default container so we can override the styles
const ToastContainer = (props) => (
  <DefaultToastContainer style={{ zIndex: "1900" }} {...props} />
);

function App() {
  return (
    <div>
      <Helmet>
      </Helmet>
      <Suspense fallback={"Loading..."}>
        <ThemeProvider theme={theme}>
          <Router>
            <Routes>
              {/* <Route exact path='/' element={<Login />} /> */}
              <Route path="/confirm-registration" element={<Onboarding />} />
              <Route
                path="/set-password"
                element={<ActivateAccountBySettingPassword />}
              />
              <Route
                path="/successful-onboarding"
                element={<FinalOnboarding />}
              />
              <Route element={<LoggedInRoute />}>
                <Route path="/" element={<Login />} />
              </Route>
              <Route path="/create-account" element={<SignupPage />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/otp-password" element={<OtpPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/reset-password-success"
                element={<ResetPasswordSuccess />}
              />
              
              {/* FLEX DEAL ROUTES */}
              <Route
                path="/flex-deal/facial-verification"
                element={<FlexDealFacialVerification />}
              />

              {/* DASHBOARD */}
              <Route element={<ProtectedRoutes />}>
                <Route path={"user"} element={<Holding />} />
                <Route
                  path={"kyc-verification"}
                  element={<KYCVerification />}
                />
                <Route path="/dashboard" element={<Dashboard />}>
                  <Route index element={<DashboardIndexSection />} />
                  <Route path="account-setup" element={<AccountSetup />} />

                  <Route path="wallet" element={<Wallet />} />
                  
                  <Route path="settings" element={<Outlet />}>
                    <Route index element={""} />
                    <Route
                      path="change-pin"
                      element={<PaymentTransactions />}
                    />
                    <Route
                      path="change-password"
                      element={<PaymentDisbursments />}
                    />
                    <Route path="reset-pin" element={<TransactionPin />} />
                    <Route path="account-limit" element={<AccountLimit />} />
                    <Route
                      path="change-bank-account"
                      element={<ChangeBankAccount />}
                    />
                    <Route path="profile" element={<Profile />} />
                    <Route path="support" element={<Support />} />
                  </Route>

                  <Route
                    path="agency-management/add-downline"
                    element={<AddDownline />}
                  />
                  <Route
                    path="agency-management/downline"
                    element={<DownLines />}
                  />
                  <Route
                    path="agency-management/downline/:id"
                    element={<DownlineDetails />}
                  />
                  <Route
                    path="agency-management/add-aggregator"
                    element={<AddAggregators />}
                  />
                  <Route
                    path="agency-management/aggregator"
                    element={<Aggregators />}
                  />

                  <Route
                    path="agency-banking/fund-wallet"
                    element={<FundWallet />}
                  />

                  <Route
                    path="agency-banking/send-money"
                    element={<SendMoney />}
                  />

                  <Route path="product/buy-airtime" element={<BuyAirtime />} />
                  <Route path="product/betting" element={<Betting />} />

                  <Route path="product/buy-data" element={<BuyData />} />

                  <Route path="product/electricity" element={<Electricity />} />

                  <Route path="products" element={<Products />} />
                  <Route
                      path="product/subscribe-cable-tv"
                      element={<CableTv />}
                  />
                  <Route
                      path="report/main-wallet"
                      element={<ReportMainWallet />}
                  />

                  <Route
                      path="report/commision-wallet"
                      element={<CommissionWalletReport />}
                  />
                  <Route
                      path="report/pending-transaction"
                      element={<PendingTransaction />}
                  />
                  <Route path="commision" element={<Commission />} />
                  <Route path="performance" element={<Performance />} />
                  <Route path="*" element={<NoPage />} />
                </Route>

                <Route path="*" element={<NoPage />} />
              </Route>
            </Routes>
          </Router>
          <ToastContainer />
        </ThemeProvider>
      </Suspense>
    </div>
  );
}

export default App;
